import { Preferences } from "./useSearchBarParams";

export function cleanFormikValues<T extends object>(
  formikValues: T,
  { exclude = [], replaceSlashes = [] }: Preferences<T>
) {
  const formikCopy: T = { ...formikValues };

  for (const item in formikCopy) {
    const value = formikCopy[item];
    if (!value) {
      delete formikCopy[item];
    }
  }

  exclude.forEach(item => {
    delete formikCopy[item];
  });

  replaceSlashes.forEach(item => {
    const value = formikCopy[item];
    if (value && typeof value === "string") {
      (formikCopy as any)[item] = value.replace(/\//g, "-");
    }
  });

  return formikCopy;
}

export function buildUrlQueryString<T extends object>(formikValues: T): string {
  const searchParams = new URLSearchParams();
  const queryValues = Object.entries(formikValues);

  for (const [key, value] of queryValues) {
    searchParams.append(key, value);
  }

  return `?${searchParams.toString()}`;
}

export default function buildAndCleanQueryString<T extends object>(
  formValues: T,
  preferences: Preferences<T> = {}
): string {
  const cleanValues = cleanFormikValues(formValues, preferences);
  return buildUrlQueryString(cleanValues);
}
